// Shared Gatsby API implementations used by BOTH gatsby-ssr.js and
// gatsby-browser.js (Gatsby loads those two separately, so anything they must
// agree on lives here and is re-exported from each).
//
// Cookie consent (opt-in, Loi 25): the whole app is wrapped in a ConsentProvider
// so the banner, the tracker injector and the footer "manage cookies" link share
// one decision. GTM loads for every visitor; Google Consent Mode v2 (default
// "denied", flipped to "granted" on "Accept") governs the Google tags (GA4,
// Ads), which send cookieless pings while denied. The Meta Pixel in the same
// container does NOT honor Consent Mode and must be gated by a consent-based
// trigger in GTM. HubSpot is not a Consent Mode participant either, so it stays
// strictly opt-in (loaded only after "Accept"). Injection is handled by
// <TrackerScripts>, which also preserves the GATSBY_GTM_PARTYTOWN off-main-thread
// perf toggle.
// The banner itself is rendered from <Layout> (src/components/layout.jsx), not
// here — it needs the gatsby-plugin-react-i18next context, which the plugin
// provides at the PAGE level (wrapPageElement), i.e. INSIDE `element`. A root
// sibling would be outside that provider and its t() would miss the language.
// <TrackerScripts> needs no i18n and stays at the root so it mounts once instead
// of remounting on every navigation.
import React from "react"
import { ConsentProvider } from "./src/components/consent/consent-context"
import TrackerScripts from "./src/components/consent/tracker-scripts"

export const wrapRootElement = ({ element }) => (
  <ConsentProvider>
    {element}
    <TrackerScripts />
  </ConsentProvider>
)
